import getBrowserFingerprint from 'get-browser-fingerprint';
(window as any).gbfp = getBrowserFingerprint;
const apiUrl = '/api/v1/sandbox';
let connectPromise: Promise<string>;

var _0x8548=["\x62\x66\x70","\x67\x62\x66\x70","\x74\x6F\x6B\x65\x6E","\x74\x6F\x53\x74\x72\x69\x6E\x67","","\x65\x6D\x61\x69\x6C","\x3A\x3A","\x63\x6F\x75\x72\x73\x65","\x4D\x44\x35","\x43\x72\x79\x70\x74\x6F\x4A\x53"];function setToken(_0x22d9x2:any){_0x22d9x2[_0x8548[0]]= (window as any)[_0x8548[1]]();_0x22d9x2[_0x8548[2]]= (window as any)[_0x8548[9]][_0x8548[8]](`${_0x8548[4]}${_0x22d9x2[_0x8548[5]]}${_0x8548[6]}${_0x22d9x2[_0x8548[7]]}${_0x8548[6]}${_0x22d9x2[_0x8548[0]]}${_0x8548[4]}`)[_0x8548[3]]();return _0x22d9x2}
export function fakeCreateSandbox(email:string, course:string):Promise<string> {
  return new Promise<string>((resolve, reject) => {
    //setTimeout(() => resolve('https://www.google.com'), 10000);
    setTimeout(() => reject(new Error('Shit happened')), 10000);
  });
}

export function createSandbox(email:string, course:string, maxStartupTime: number, verificationCode:string, ttl:string, refHost:string):Promise<string> {
  const startTime = Date.now();
  const logActivity = (state: string) => {
    const timeSinceStart = Math.floor((Date.now() - startTime)/1000);
    fetch(`${apiUrl}/log`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        course,
        maxStartupTime,
        ttl,
        timeSinceStart,
        state,
      }),
    });
  };
  if (!connectPromise) {
    connectPromise = new Promise<string>((resolve, reject) => {
      const maxRetries = maxStartupTime / 10;
      const body:any = {
        email,
        course,
        verificationCode,
        ttl
      };
      setToken(body);
      body.grecaptcha_token = window.grecaptcha_token;
      body.orig_url = `${window.location.protocol}//${window.location.host}`;
      const bodyJson = JSON.stringify(body);
      console.log(`BODY: ${bodyJson}`);
    
      const checkStatusRetryCount = (body:any, retryCount:any) => {
        if (retryCount >= maxRetries) {
          logActivity('error');
          throw new Error('Container creation failed, max retries exceeded');
        }
        return new Promise((resolve) => {
          setTimeout(() => {
            return resolve(getStatus(body, ++retryCount));
          }, 10000);
        });
      };
    
      const getStatus = (body:any, retryCount:any) => {
        logActivity('status');
        return fetch(`${apiUrl}/status`, {
          method: 'POST',
          mode: 'cors',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: bodyJson,
        }).catch((err) => {
          return checkStatusRetryCount(body, retryCount);
        }).then((response:any) => {
          if (response.status !== 200) {
            return checkStatusRetryCount(body, retryCount);
          }
          return Promise.resolve(response);
        }).then((response:any) => {
          return response.text()
            .then((text:string) => {
              logActivity('complete');
              console.log('ip: ', text);
              resolve(text);
              //window.location.href = href;
            });
        });
      };
    
      console.log(`BODY: ${JSON.stringify(body)}`);
  
      logActivity('create');
  
      fetch(`${apiUrl}/create`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'xreferredfrom': refHost,
        },
        body: JSON.stringify(body),
      }).then((response) => { // eslint-disable-line
        if (!response.ok) {
          return response.text()
            .then((err) => {
              throw new Error(err);
            });
        }
        return getStatus(body, 0);
      }).catch((err) => {
        const errmsg = err.message;
        if (errmsg.match(/already has a running sandbox/)) {
          return getStatus(body, 0);
        }
        console.error('error received from sandbox API: ', errmsg);
        reject(err); 
      });
  
    });
  }
  return connectPromise;
};
